export const normalizeYearQuarter = ({
  year,
  quarter,
  shouldShift,
}: {
  year: number | string;
  quarter: number | string;
  shouldShift?: boolean;
}): { year: number; quarter: number } => {
  const numberQuarter = Number(quarter);
  const numberYear = Number(year);

  if (Number.isNaN(numberQuarter) || Number.isNaN(numberYear)) {
    throw new Error('Invalid year or quarter');
  }

  if (shouldShift) {
    if (numberQuarter === 4) {
      return {
        year: numberYear + 1,
        quarter: 1,
      };
    } else {
      return {
        year: numberYear,
        quarter: numberQuarter + 1,
      };
    }
  }

  return {
    year: numberYear,
    quarter: numberQuarter,
  };
};
